<template>
  <section class="block p-4 mt-3 text-sm text-gray-600 pdf-item">
    <div class="block text-xs text-left">{{ $t("main.disclaimer") }}</div>
    <div class="block px-4 py-2 mt-8 text-center bg-gray-100 rounded-lg">
      Ravensberger Schmierstoffvertrieb GmbH | Jöllenbecker Str. 2 | 33824
      Werther / Germany Telefon: +49 5203 9719 0 | Telefax: +49 5203 9719 40 |
      E-Mail: kontakt@ravenol.de www.ravenol.de
    </div>
  </section>
</template>

<script>
export default {};
</script>

<style></style>
